import { USER_JURISDICTION_UPDATED } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class JurisdictionModulesService {
  constructor(defaultJurisdiction) {
    this.modules = {};
    if (this.isModular(defaultJurisdiction)) {
      this.setupModule(defaultJurisdiction);
    }
    window.eventBus.subscribe(USER_JURISDICTION_UPDATED, (event) => {
      if (this.jurisdiction && this.isModular(this.jurisdiction)) {
        this.destroyModule(this.jurisdiction);
      }
      this.jurisdiction = event.payload;
      if (this.isModular(this.jurisdiction)) {
        this.setupModule(this.jurisdiction);
      }
    }, { replay: true, distinct: true });
  }
  setupModule(jurisdiction) {
    return __async(this, null, function* () {
      const module = yield this.getModule(jurisdiction);
      module.setup();
    });
  }
  destroyModule(jurisdiction) {
    return __async(this, null, function* () {
      const module = yield this.getModule(jurisdiction);
      module.destroy();
    });
  }
  getJurisdictionFormConfig(nextButtonEnabled) {
    return __async(this, null, function* () {
      if (this.jurisdiction && this.isModular(this.jurisdiction)) {
        const module2 = yield this.getModule(this.jurisdiction);
        return module2.signUpFormConfig(nextButtonEnabled);
      }
      const module = yield import(
        /* webpackChunkName: "account" */
        '@gig/magic-jurisdictions/dist/configs'
      );
      if (this.jurisdiction === Jurisdiction.UKGC) {
        return module.UKGCSignupFormConfig(nextButtonEnabled);
      }
      return module.defaultSignupFormConfig(nextButtonEnabled);
    });
  }
  getModule(jurisdiction) {
    return __async(this, null, function* () {
      const module = this.modules[jurisdiction];
      if (module) {
        return module;
      }
      if (jurisdiction === Jurisdiction.AGCO) {
        this.modules[jurisdiction] = yield import(
          /* webpackChunkName: "agco" */
          '@gig/magic-agco'
        );
      }
      if (jurisdiction === Jurisdiction.LOTBA) {
        this.modules[jurisdiction] = yield import(
          /* webpackChunkName: "lotba" */
          '@gig/magic-lotba'
        );
      }
      if (jurisdiction === Jurisdiction.ONJN) {
        this.modules[jurisdiction] = yield import(
          /* webpackChunkName: "onjn" */
          '@gig/magic-onjn'
        );
      }
      if (jurisdiction === Jurisdiction.EMTA) {
        this.modules[jurisdiction] = yield import(
          /* webpackChunkName: "emta" */
          '@gig/magic-emta'
        );
      }
      return this.modules[jurisdiction];
    });
  }
  isModular(jurisdiction) {
    return jurisdiction === Jurisdiction.AGCO || jurisdiction === Jurisdiction.LOTBA || jurisdiction === Jurisdiction.ONJN || jurisdiction === Jurisdiction.EMTA;
  }
}

export { JurisdictionModulesService };
